// Copyright © 2021 Move Closer
import { NoAccessPath, SubscriptionRequiredPath } from './routes.config';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const routesFactory = () => {
    return [
        {
            path: NoAccessPath,
            name: 'no-access',
            component: () => import(/* webpackChunkName: "NoAccessView" */ './views/NoAccessView.vue'),
            meta: { skipAuthModal: true }
        }, {
            path: SubscriptionRequiredPath,
            name: 'buy-subscription',
            redirect: { name: 'content.no-access' }
        }, {
            path: '/simple-preview/*',
            name: 'simple-preview',
            component: () => import(/* webpackChunkName: "SimplePreview" */ './views/SimplePreviewView.vue'),
            meta: { layout: 'clear' }
        }, {
            path: '/preview-cms/:variantId',
            name: 'preview-cms',
            component: () => import(/* webpackChunkName: "CmsPreview" */ './views/CmsPreviewView.vue'),
            meta: { layout: 'clear' }
        }, {
            path: '/search',
            name: 'search',
            component: () => import(/* webpackChunkName: "SearchView" */ './views/SearchView.vue')
        }, {
            // url.includes('/favicon.ico') ||
            //   url.includes('/robots.txt') ||
            //   url.includes('/sitemap.xml') ||
            //   url.includes('/ads.txt') ||
            //   url.match(/\.(css|js|png|jpg|jpeg|gif|ico|svg|woff|woff2|ttf|eot)(\?.*)?$/)) {
            path: '/.well-known/*',
            name: '404',
            component: () => import(/* webpackChunkName: "ContentView" */ './views/404.vue')
        }, {
            path: '*',
            name: 'content',
            component: () => import(/* webpackChunkName: "ContentView" */ './views/ContentView.vue')
        }
    ];
};
